import template from './electricity-power.jade';
import validation from './../../../services/validation';

export default angular
  .module('cian.addForm.aboutObjectElectricityPower', [])
  .directive('cianAfAboutObjectElectricityPower', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller(deviceService) {
      'ngInject';
      this.isMobile = deviceService.isMobile;
      this.ad.electricity = this.ad.electricity || {};

      this.maxPower = 1000;
      this.minPower = 0;

      this.validation = validation(this.form, 'electricity.power', {
        parse: 'Введите число',
        max: 'Допустимо не более 3 символов',
        min: 'Введите число',
      });
    },
    controllerAs: 'electricityPower',
    template,
  })).name;
